<template>
  <div id="app-loader" v-if="isLoading">
    <img src="@/assets/images/b2b/icon.png" alt class="img-fluid loader" width="200" height="200"/>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Loading",
  computed: mapState("app", {
    isLoading: (state) => state.isAppLoading,
  }),
};
</script>
<style>
#app-loader {
  position: fixed;
  z-index: 9999;
  height: 200px;
  width: 200px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
#app-loader:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.07);
}

.loader{
  position: relative;
  animation: 1.2s linear 0s infinite normal forwards running slide-ltr
}
@keyframes slide-ltr
{
  0% {
    animation-timing-function: cubic-bezier(0.4652,0.1051,0.774,0.6426);
    transform: translate(0px,0px) rotate(0deg) scale(1,1) skewX(0deg) skewY(0deg);
    opacity: 1;
  }
  22.5% {
    animation-timing-function: cubic-bezier(0.4142,0.3131,0.7623,0.6513);
    transform: translate(47.8px,0px) rotate(0deg) scale(1,1) skewX(0deg) skewY(0deg);
    opacity: 1;
  }
  45% {
    animation-timing-function: cubic-bezier(0.3615,0.331,0.9646,1.3461);
    transform: translate(147.8px,0px) rotate(0deg) scale(1,1) skewX(0deg) skewY(0deg);
    opacity: 1;
  }
  47.5% {
    animation-timing-function: cubic-bezier(0.7006,0.3332,0.6667,0.6667);
    transform: translate(165.6px,0px) rotate(0deg) scale(1,1) skewX(0deg) skewY(0deg);
    opacity: 0;
  }
  50% {
    animation-timing-function: cubic-bezier(0.1604,0.3176,-0.0218,0.6965);
    transform: translate(-200px,0px) rotate(0deg) scale(1,1) skewX(0deg) skewY(0deg);
    opacity: 0;
  }
  51% {
    animation-timing-function: cubic-bezier(0.1983,0.3529,0.5263,0.6945);
    transform: translate(-179.8px,0px) rotate(0deg) scale(1,1) skewX(0deg) skewY(0deg);
    opacity: 0;
  }
  80.4% {
    animation-timing-function: cubic-bezier(0.2342,0.3708,0.5422,0.9065);
    transform: translate(-38.4px,0px) rotate(0deg) scale(1,1) skewX(0deg) skewY(0deg);
    opacity: 1;
  }
  100% {
    transform: translate(0px,0px) rotate(0deg) scale(1,1) skewX(0deg) skewY(0deg);
    opacity: 1;
  }
}

</style>